'use strict';

/**
 * Singleton instance used to add and manage Firebase sync triggers for all resources
 */

var _ = require('lodash');
var Firebase = require('firebase');

module.exports = new Syncify();

function Syncify () {
  
  var syncListeners = {};

  /**
   * Attachs sync listeners to the resource. When one of the attached change listeners are 
   * triggered, it will execute the attached callback.
   * 
   * @param {Object|Array} triggers trigger definition(s)
   * @param {Object} resource the resource that should sync
   */
  this.addSyncListeners = (function () {

    function error (endpoint, token, err) {
      console.error(err.message + '\n Endpoint: %s \n Token: %s', endpoint, token, err);
    }

    function addSyncListener (resourceName, trigger, callback) {
      
      var endpoint = getTriggerEndpoint(trigger.basePath, trigger.endpoint);
      var resourceSyncListeners = syncListeners[resourceName] || {};

      if (!resourceSyncListeners[endpoint]) {
        var ref = getFirebaseRef(endpoint, trigger.token);
        var cb = ref.on('value', function (snapshot) {
          var timestamp = snapshot && snapshot.val() || 0;
          callback(timestamp);
        }, error.bind(null, endpoint, trigger.token));

        resourceSyncListeners[endpoint] = {ref: ref, callback: cb};
        syncListeners[resourceName] = resourceSyncListeners;
      }
    }
    
    return function addSyncListeners (resourceName, triggers, callback) {
      if (Array.isArray(triggers)) {
        _.forEach(triggers, function (trigger) {
          addSyncListener(resourceName, trigger, callback);
        });
      } else if (typeof triggers === 'object') {
          var trigger = triggers;
          addSyncListener(resourceName, trigger, callback);
      } else {
        throw new Error('Wrong parameter type for: triggers');
      }
    };
  })();

  /**
   * Remove a specific sync listener
   *
   * @param {String} resourceName
   * @param {Object|String} trigger Trigger object or the full firebase endpoint
   */
  this.removeSyncListener = function (resourceName, trigger) {
    var firebaseEndpoint, listener;
    var resourceSyncListeners = syncListeners[resourceName];

    if (typeof trigger === 'object') {
      firebaseEndpoint = getTriggerEndpoint(trigger.basePath, trigger.endpoint);
    } else {
      firebaseEndpoint = trigger;
    }

    listener = resourceSyncListeners[firebaseEndpoint];
    
    if (listener) {
      var ref = listener.ref;
      var callback = listener.callback;
      ref.off('value', callback);
    }

    delete resourceSyncListeners[firebaseEndpoint];
  };

  /**
   * Remove a specific sync listener or set of listeners
   * 
   * @param {String} resourceName
   * @param {Array|Object|String} triggers Array of triggers (objects|strings) or a single trigger (object|string)
   */
  this.removeSyncListeners = function (resourceName, triggers) {
    var _this = this;
    if (Array.isArray(triggers)) {
      _.forEach(triggers, function (trigger) {
        _this.removeSyncListener(resourceName, trigger);
      });
    } else if (typeof triggers === 'object' || typeof triggers === 'string') {
      var trigger = triggers;
      _this.removeSyncListener(resourceName, trigger);
    }
  };

  /**
   * Remove all sync listeners for the specified resource
   */
  this.removeAllResourceSyncListeners = function (resourceName) {
    var resourceSyncListeners = syncListeners[resourceName];

    _.forEach(resourceSyncListeners, function (listener) {
      var ref = listener.ref;
      var callback = listener.callback;
      ref.off('value', callback);
    });

    syncListeners[resourceName] = {};
  };

  /**
   * Remove all sync listeners for all resources
   */
  this.removeAllSyncListeners = function () {
    var this_ = this;
    _.forEach(syncListeners, function (listeners, resourceName) {
      this_.removeAllResourceSyncListeners(resourceName);
    });

    // update reference
    this.$$syncListeners = syncListeners = {};
  };

  /////////////////////////////////////////////////////////////////////////////////////////////////
  // Helpers
  /////////////////////////////////////////////////////////////////////////////////////////////////

  /**
   * Get the trigger (firbase) endpoint by combining the basepath and endpoint
   * 
   * @param  {String} basePath [description]
   * @param  {String} endpoint [description]
   * @return {String}          [description]
   */
  var getTriggerEndpoint = function (basePath, endpoint) {

    if (!basePath) {
      throw new Error('Missing parameter: basePath');
    }

    if (!endpoint) {
      throw new Error('Missing parameter: endpoint');
    }

    // remove trailing slash or starting forward slash
    basePath = basePath.replace(/^\/|\/$/g, '');
    endpoint = endpoint.replace(/^\/|\/$/g, '');
    return [basePath, endpoint].join('/');
  };

  var getFirebaseRef = function (endpoint, token) {
    var ref = new Firebase(endpoint);

    if (token) {
      ref.authWithCustomToken(token, function (err) {
        if (err) {
          console.error(err);
        }
      });
    }

    return ref;
  };

  /////////////////////////////////////////////////////////////////////////////////////////////////
  // Exposed for Testing
  /////////////////////////////////////////////////////////////////////////////////////////////////

  this.$$getTriggerEndpoint = getTriggerEndpoint;
  this.$$syncListeners = syncListeners;
}


// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/data/src/core/Syncify.js